import securityService from '../services/security';

export default {
    namespaced: true,
    state: () => ({
      navbarTitle: '',
      user: JSON.parse(localStorage.getItem('user')),
      menu: [],
      language: localStorage.getItem('language') ?? 'en',
      userPreferences: [],
      navigationHistory: [],
      uiPermissions: {},
      gridConfigurations: JSON.parse(localStorage.getItem('gridConfigurations')) ?? {}
    }),
    mutations: {
      setNavbarTitle(state, title){
        state.navbarTitle = title;
      },
      setUser(state, user){
        state.user = user;
        localStorage.setItem("user", JSON.stringify(user));
      },
      setMenu(state, menu){
        state.menu = menu;
      },
      setLanguage(state, language){
        state.language = language;
        localStorage.setItem("language", language);
      },
      setUiPermissions(state, data){
        state.uiPermissions = data;
      },
      logout(state){
        state.user = null;
        localStorage.removeItem('user');
      },
      setUserPreferences(state, data){
        state.userPreferences = data;
      },
      addNavigationHistory(state, data){
        state.navigationHistory.push(data);
      },
      removeNavigationHistory(state, data){
        state.navigationHistory = state.navigationHistory.filter(function(value){ 
          return value.href != data;
      });
      },
      setGridConfigurations(state, conf){
        state.gridConfigurations[conf.name] = conf.configuration;
        localStorage.setItem("gridConfigurations", JSON.stringify(state.gridConfigurations));
      },
    },
    actions: {
      setNavbarTitle({commit}, payload){
        commit("setNavbarTitle", payload)
      },
      setUser({commit}, payload){
        commit("setUser", payload);
      },
      setMenu({commit}, payload){
        commit("setMenu", payload);
      },
      setLanguage({commit}, payload){
        commit("setLanguage", payload);
      },
      setUiPermissions({commit}, payload){
        commit("setUiPermissions", payload);
      },
      logout({commit}){
        commit("logout");
      },
      setUserPreferences({commit}, payload){
        commit("setUserPreferences", payload);
      },
      addNavigationHistory({commit}, payload){
        commit("addNavigationHistory", payload)
      },
      removeNavigationHistory({commit}, payload){
        commit("removeNavigationHistory", payload)
      },
      async login({commit}, payload){
        await securityService.login(payload.body, payload.callback);
      },
      setGridConfigurations({commit}, payload){
        commit("setGridConfigurations", payload);
      },
    },
    getters: {
      userId(state){
        return state.user ? state.user.userId: null
      },
      userMenu(state){
        return state.menu;
      },
      userLanguage(state){
        return state.language;
      },
      navbarTitle(state){
        return state.navbarTitle;
      },
      uiPermissions: (state) => (attribute) => {
        return state.uiPermissions.isSuperAdmin ? {isHidden: false, isEnabled: true} :
         //return 
         ( state.uiPermissions?.rolePermission?.[attribute] ?
          {isHidden: false, isEnabled: state.uiPermissions?.rolePermission?.[attribute] === 'enabled'}
          : {isHidden: true, isEnabled: false} )
      },
      gridConfiguration: (state) => (name) => {
        return state.gridConfigurations[name];
      }
    }
  }